import { render, staticRenderFns } from "./DueDeligenceReports.vue?vue&type=template&id=523448d0&scoped=true"
import script from "./DueDeligenceReports.vue?vue&type=script&lang=js"
export * from "./DueDeligenceReports.vue?vue&type=script&lang=js"
import style0 from "./DueDeligenceReports.vue?vue&type=style&index=0&id=523448d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523448d0",
  null
  
)

export default component.exports